/*
 * @Description:
 * @Date: 2021-06-17 15:05:33
 */

import payProgress from '../child/orderPayProgress/index.vue';
import orderDetail from '../child/orderDetail/index.vue';

export default {
  projectSubmit: {
    label: '结算日期',
    prop: 'projectSubmit',
    width: 140
  },
  link_zhifujindu: {
    label: '支付进度',
    render: function(h, ctx, r) {
      const { projectId, projectIndustryFenpeiId, projectName, payType } = r;
      const showDialog = () => {
        const diglog = ctx.parent.$xrkDialog({
          title: '支付进度',
          width: '90vw',
          // top:'5vh',
          $slots: {
            // default: h(priceDetailUpdate),
            default: h(payProgress, {
              props: {
                row: {
                  projectId,
                  projectIndustryFenpeiId,
                  projectName,
                  payType
                }
              }
            }),
            footer: h(
              'div',
              {
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '10px 50px'
                }
              },
              [
                h(
                  'el-button',
                  {
                    props: {},
                    on: {
                      click: () => {
                        diglog.remove();
                      }
                    }
                  },
                  '关闭'
                )
              ]
            )
          }
        });
      };

      // 已支付数量 / 总支付数量
      return (
        <span
          style={{ color: '#409EFF', cursor: 'pointer' }}
          onClick={showDialog}
        >{`${r['payPeopleNum']}/${r['allPeopleNum']}`}</span>
      );
    }
  },
  listProjectCheckManageAction: {
    label: '操作',
    render: function(h, ctx, r) {
      const showDialog = () => {
        let diglog = ctx.parent.$xrkDialog({
          title: '订单详情',
          width: '90vw',
          $slots: {
            default: h(orderDetail, {
              props: {
                row: r
              }
            }),
            footer: h(
              'div',
              {
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '10px 50px'
                }
              },
              [
                h(
                  'el-button',
                  {
                    props: {},
                    on: {
                      click: () => {
                        diglog.remove();
                      }
                    }
                  },
                  '关闭'
                )
              ]
            )
          }
        });
      };

      return (
        <div>
          {/*<el-button type="text" onClick={toPay}>支付</el-button>*/}

          <el-button type="text" onClick={showDialog}>
            订单详情
          </el-button>
        </div>
      );
    }
  }
};
